const setStyleHeightToBoundingHeightForElement = (element) => {
  const { height } = element.getBoundingClientRect();
  element.style.setProperty("height", `${height}px`);
};

const unsetStyleHeight = (element) => {
  element.style.removeProperty("height");
};

export const resizeElementsForDropdown = (elementSelectors, isDropdownOpen) => {
  const elements = elementSelectors
    .map((selector) => document.querySelector(selector))
    .filter((element) => Boolean(element));

  if (isDropdownOpen) {
    elements.forEach(setStyleHeightToBoundingHeightForElement);
  } else {
    setTimeout(() => {
      elements.forEach(unsetStyleHeight);
    });
  }
};
